import axios from 'axios';
import { API_BASE_URL } from './constants';
import { getAccessToken } from '../helpers/functions';
import { Toaster } from '../helpers/toaster';
import { logoutUserEvent, refetchQuery } from '../helpers/events';
import { SETUP_STATUS_QUERY_KEY } from '../pages/ProtectedPages/ProviderOnboarding/constants';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const { state } = JSON.parse(getAccessToken()) || {};
    if (state?.token && !config?.headers?.Authorization) {
      config.headers['Authorization'] = `Bearer ${state?.token}`;
    }
    return config;
  },
  (error) => {
    throw new Error(error);
  },
);

/**
 * The API refuses ordinary calls while a tenant's first-run setup is missing.
 * That answer is authoritative and can start at any moment — a field cleared
 * in the database mid-session, for instance — so it re-asks the setup gate
 * instead of leaving the user on a dashboard the server has stopped serving.
 * The error is still reported: silencing it once meant a genuinely broken
 * account looked merely empty.
 */
const SETUP_ERROR_CODES = ['integration_incomplete', 'setup_incomplete'];

apiClient.interceptors.response.use((response) => {
    return response;
  },
  async (error) => {
    console.log("🚀 ~ error:", error)
    if (error?.response?.status === 401) {
      document.dispatchEvent(logoutUserEvent);
    }

    const payload = error?.response?.data?.data?.[0];
    if (SETUP_ERROR_CODES.includes(payload?.code)) {
      document.dispatchEvent(refetchQuery(SETUP_STATUS_QUERY_KEY));
    }

    Toaster.error(payload?.msg ?? 'Something went wrong');
    return Promise.reject(error);
  },
);
